import React from 'react';
import { Form } from 'antd';

//mobx
import { useStore } from '@/store';
import { observer } from 'mobx-react-lite';

import 'moment/locale/zh-cn';


const App = () => {
    //mobx
    const { DeviceStore } = useStore()

    return (
        <>
            <Form
                labelCol={{
                    span: 6,
                }}
                wrapperCol={{
                    span: 14,
                }}
            >
                <Form.Item
                    label="设备ID"
                >
                    {DeviceStore.seevalue.DevId}
                </Form.Item>
                <Form.Item
                    label="设备名称"
                >
                    {DeviceStore.seevalue.DevName}
                </Form.Item>
                <Form.Item
                    label="设备编号"
                >
                    {DeviceStore.seevalue.DevCode}

                </Form.Item>
                <Form.Item
                    label="链接时间"
                >
                    {DeviceStore.seevalue.ConnTime}
                </Form.Item>
            </Form>
        </>
    )
}
export default observer(App)